import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import _ from "lodash";
import Select from "react-select";
import LeaveCarryoverModal from "./LeaveCarryoverModal";
import { ArrowTopRightOnSquareIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/20/solid";
import { validateFloat } from "../common/validation/Validators";
import { CustomOption } from "@/common/custom-selectors/CustomOption";

const carryoverOptions = [
	{
		label: "Do Not Carryover",
		value: "Do Not Carryover",
	},
	{
		label: "Carryover All",
		value: "Carryover All",
	},
	{
		label: "Max Carryover Hours",
		value: "Max Carryover Hours",
	},
	// {
	//   label: "Max Payable Hours",
	//   value: "Max Payable Hours",
	// },
];

const thisYear = new Date().getFullYear();

const LeaveCarryover = ({ openModal, setMaxCarryover, carryoverValues, carryoverYear, modalStatus }) => {
	useEffect(() => {
		setMaxCarryover(0, 0, false);
	}, [setMaxCarryover]);

	const maxCarryover = carryoverValues?.maxCarryover;
	const maxPayable = carryoverValues?.maxPayable;
	// const [loaded, setLoaded] = useState(false);
	const [carryoverOption, setCarryoverOption] = useState(carryoverOptions[0]);

	useEffect(() => {
		if (carryoverYear && carryoverYear >= thisYear) return;
		switch (carryoverOption?.value) {
			case "Do Not Carryover":
				setMaxCarryover(0, 0, false);
				return;
			case "Carryover All":
				setMaxCarryover(1080, 0, true);
				return;
			case "Max Carryover Hours":
				setMaxCarryover(108, 0, false);
				return;
			case "Max Payable Hours":
				setMaxCarryover(0, 108, false);
				return;
			default:
				setMaxCarryover();
		}
	}, [carryoverOption]);

	if ((carryoverYear && carryoverYear >= thisYear) || thisYear == 2022) return null;
	if (modalStatus) return <LeaveCarryoverModal />;

	return (
		<>
			<div className="content bg-primary">
				<h2
					className="page-heading"
					style={{ color: "#fff", textAlign: "left", marginBottom: 20 }}
				>
					Leave Carryover {thisYear}
				</h2>

				{/*<div className="col-xs-4">
					<label htmlFor="material-text">Carryover Option</label>
					<Select
						value={carryoverOption}
						options={carryoverOptions}
						onChange={setCarryoverOption}
						components={{ Option: CustomOption }}
					/>
					<div className="clearfix" />
        </div>*/}

        <a href="https://support.buddy.hr/hc/en-mt/articles/4414149404434-Carryover-or-Pay-Leave-Balances-from-Previous-Year"
          target="_blank" className="hover:underline text-white">
            <ArrowTopRightOnSquareIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
          According to your agreement with your employees, an amount of leave not exceeding 50% of entitled leave can be carried forward to the following year if it is not utilised.
        </a>

				{carryoverOption?.value == "Max Carryover Hours" && (
					<div
						className="col-xs-4"
						style={{ paddingRight: 0 }}
					>
						<label htmlFor="material-text">Maximum Leave Hours To Carryover</label>
						<input
							className="form-control"
							type="text"
							name="maxHours"
							onChange={(e) => {
								setMaxCarryover(validateFloat(e.target.value), 0, false);
							}}
							style={{ height: 38 }}
							value={maxCarryover}
						/>
						<div className="clearfix" />
					</div>
				)}
				{/* {carryoverOption?.value == "Max Payable Hours" && (
					<div
						className="col-xs-4"
						style={{ paddingRight: 0, }}
					>
						<label htmlFor="material-text">Maximum Leave Hours To Pay</label>
						<input
							className="form-control"
							type="text"
							name="maxHours"
							onChange={(e) => {
								if (!isNaN(e.target.value) || e.target.value == "") {
									setMaxCarryover(0, Number(e.target.value), false);
								}
							}}
							style={{ height: 38 }}
							value={maxPayable}
						/>
						<div className="clearfix" />
					</div>
				)} */}
				<div className="clearfix" />

				<div
					style={{ marginTop: 10, marginBottom: 10}}
					className="btn btn-success pull-right"
					onClick={openModal}
				>
					<ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<div style={{ float: "left" }}>Review</div>
				</div>
				<div className="clearfix" />
			</div>
			<div className="clearfix" />
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		carryoverYear: state.company?.settings?.carryover?.year,
		carryoverValues: state?.leave?.leaveCarryoverMax,
		modalStatus: !!state?.leave?.leaveCarryoverModal,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openModal: () => dispatch(LEAVEACTIONS.leaveCarryoverModal(true)),
	setMaxCarryover: (maxCarryover, maxPayable, carryoverAll) =>
		dispatch(LEAVEACTIONS.setMaxCarryover(maxCarryover, maxPayable, carryoverAll)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveCarryover);
